import CustomSelect from "app/common/components/CustomSelect";
import { fetchBanks } from "app/redux/balances/balancesHandler";
import { useEffect } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";


const CustomBankSelect = ({defaultSelect, ...props}) => {

    const dispatch = useDispatch();
    const banks = useSelector(({balances}) => balances.banks, shallowEqual);

    // Retrieve banks if not in state
    useEffect(_ => {
        if (!banks) {
            dispatch(fetchBanks());
        }
    }, [dispatch, banks]);

    return  <CustomSelect
                data={banks}
                placeholder="Select Bank"
                searchable={true}
                defaultSelect={banks?.find(item => item.code === defaultSelect)}
                formatValue={item => item?.code}
                required
                {...props}
            /> 
}

export default CustomBankSelect;